// extracted by mini-css-extract-plugin
module.exports = {"Box":"Box_Box__TYy1V","glitch1":"Box_glitch1__3eFXp","textShadow":"Box_textShadow__DctsO"};